// TODO: combine these types
// export type StatusEnum = 'enqueued' | 'running' | 'done' | 'error' | 'cancelled';
export const enum TaskStatuses {
  ENQUEUED = 'enqueued',
  RUNNING = 'running',
  DONE = 'done',
  ERROR = 'error',
  CANCELLED = 'cancelled',
}
